import React, { Component } from 'react';
class Tooltip extends Component {
    constructor(props) {
        super(props);
        this.state = { displayTooltip: false };
        this.tooltipRef = React.createRef();
    }

    componentDidMount() {
        const {view} = this.props; 
        if(view && view === 'XML'){
            document.addEventListener('click', this.handleClickOutside, true);
        }
    }

    componentWillUnmount() {
        const {view} = this.props; 
        if(view && view === 'XML'){
            document.removeEventListener('click', this.handleClickOutside, true);
        }
    }

    handleClickOutside = (event) => {
        if (this.tooltipRef.current && !this.tooltipRef.current.contains(event.target)) {
            this.setState({ displayTooltip: false });
        }
    };

    styles = () => {
        const { position, width } = this.props;

        const tooltipStyle = {
            width: `${width || 300}px`,
            zIndex: 1000,
            fontSize: '14px',
            textAlign: 'justify',
            backgroundColor: '#6D6E71',
            borderRadius: '4px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
        };
        
        const tooltipArrowStyle = position === 'up'
            ? { bottom: '-9px', transform: 'translateX(90%)', borderLeft: '10px solid transparent', borderRight: '10px solid transparent', borderTop: '10px solid #6D6E71' }
            : { top: '-9px', transform: 'translateX(90%)', borderLeft: '10px solid transparent', borderRight: '10px solid transparent', borderBottom: '10px solid #6D6E71' };

        const tooltipPositionStyle = position === 'up'
            ? { left: '-14px', bottom: '150%' }
            : { left: '-14px', top: '150%' };

        return { tooltipStyle,  tooltipArrowStyle, tooltipPositionStyle };
    }

    renderViewXML () {
        const { tips } = this.props;
        const { tooltipStyle,  tooltipArrowStyle, tooltipPositionStyle } = this.styles();
        const { displayTooltip } = this.state;

        return (
            <>
                <i
                    className="fa fa-question-circle"
                    aria-hidden="true"
                    onClick={() => this.setState({ displayTooltip: true })}
                    style={{ cursor: 'pointer', fontSize: '15px', marginLeft: '5px', marginRight: '-5px', marginTop: '10px' }}
                ></i>
                {displayTooltip && tips && Object.entries(tips).length > 0 && (
                    <div ref={this.tooltipRef} className="card text-white border-0 position-absolute notificacion" style={{ ...tooltipStyle, ...tooltipPositionStyle }}>
                        <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                            {this.renderPropertiesXML(tips)}
                        </div>
                        <div className="position-absolute" style={tooltipArrowStyle}></div>
                    </div>
                )}
            </>
        );
    }

    renderPropertiesXML = (data) => {
        return (
            Object.entries(data).map(([key, value], index) => {
                switch (true) {
                    case (typeof value !== 'object' && !Array.isArray(value)):
                        return (
                            <div key={index} className="card-body p-2 position-relative">
                                <h5 className="card-title" style={{fontSize: '0.8rem', fontWeight: 'bold'}}>{key}</h5>
                                <div className="d-flex align-items-center flex-wrap">
                                    <span>{value}</span>
                                </div>
                            </div>
                        );
                    case Array.isArray(value):
                        return (
                            <div key={index} className="card-body p-2 position-relative">
                                <h5 className="card-title" style={{fontSize: '0.8rem', fontWeight: 'bold'}}>{key}</h5>
                                {value.map((val, index) => {
                                    return (
                                        <div key={index}>
                                            {this.renderPropertiesXML(val)}
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    case (typeof value === 'object' && value !== null):
                        return (
                            <div key={index} className="card-body p-2 position-relative">
                                <h5 className="card-title" style={{fontSize: '0.8rem', fontWeight: 'bold'}}>{key}</h5>
                                {this.renderPropertiesXML(value)}
                            </div>
                        );
                    default:
                        return null; 
                }
            })
        );
    }

    render() {
        const { displayTooltip } = this.state;
        const { tips, view } = this.props;
        const { tooltipStyle,  tooltipArrowStyle, tooltipPositionStyle } = this.styles();
        return (
            <div className="position-relative">
                {!view ? (
                    <>
                        <i
                            className="fa fa-question-circle"
                            aria-hidden="true"
                            onMouseOver={() => this.setState({ displayTooltip: true })}
                            onMouseOut={() => this.setState({ displayTooltip: false })}
                            style={{ cursor: 'pointer', fontSize: '15px', marginLeft: '5px', marginRight: '-5px' }}
                        ></i>
                        {displayTooltip && tips && tips.length > 0 && (
                            <div className="card text-white border-0 position-absolute notificacion" style={{ ...tooltipStyle, ...tooltipPositionStyle }}>
                                {tips.map((tip, index) => (
                                    <div key={index} className="card-body p-2 position-relative">
                                        {tip.title && tip.title !== '' && (
                                            <h5 className="card-title" style={{ fontSize: '0.8rem', fontWeight: 'bold' }}>{tip.title}</h5>
                                        )}
                                        <div className="d-flex align-items-center flex-wrap">
                                            <span>{tip.message}</span>
                                        </div>
                                    </div>
                                ))}
                                <div className="position-absolute" style={tooltipArrowStyle}></div>
                            </div>
                        )}
                    </>
                ) : (
                    this.renderViewXML()
                )}
            </div>
        );
    }
}

export default Tooltip;